import { render, staticRenderFns } from "./AccountTabs.vue?vue&type=template&id=18b82ec3&scoped=true"
import script from "./AccountTabs.vue?vue&type=script&lang=js"
export * from "./AccountTabs.vue?vue&type=script&lang=js"
import style0 from "./AccountTabs.vue?vue&type=style&index=0&id=18b82ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b82ec3",
  null
  
)

export default component.exports